import { DateTime } from 'luxon';

export function parseDateValue(value: unknown): Date | null {
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    if (typeof value !== 'string' || !value.trim()) {
        return null;
    }

    const normalizedValue = value.trim();
    const localizedDate = DateTime.fromFormat(normalizedValue, 'dd.MM.yyyy', { zone: 'local' });
    const parsedDate = localizedDate.isValid ? localizedDate : DateTime.fromISO(normalizedValue, { zone: 'local' });

    return parsedDate.isValid ? parsedDate.toJSDate() : null;
}
